import LandingPage from "./LandingPage";
import { houstonContent } from "./content/houston";

export default function HoustonPage() {
  return <LandingPage content={houstonContent} />;
}
